import React, { useEffect, useState } from "react";
import { pageDetailApiService } from "../../services/apiService";
import { Container } from "react-bootstrap";

const BookPackagesV1 = () => {
  const [pageData, setPageData] = useState({});
  const getPageData = () => {
    const body = {
      pageTitle: "CONTACT US",
    };
    pageDetailApiService.getPageDetails(body).then((response) => {
      if (response.data.status === true) {
        const responseData = response.data.data.pageData;
        setPageData(responseData);
      }
    });
  };

  useEffect(() => {
    getPageData();
  }, []);

  useEffect(() => {
    // Load the iframe-resizer library dynamically
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.6.1/iframeResizer.min.js";
    script.onload = () => {
      // Initialize the iFrameResizer if available
      if (window.iFrameResize) {
        window.iFrameResize(
          {
            log: false,
            checkOrigin: false,
            tolerance: 10,
            sizeHeight: true,
            heightCalculationMethod: "lowestElement",
            minHeight: window.innerHeight,
            scrolling: "auto",
          },
          "#glofox_6"
        );
      }
    };
    document.body.appendChild(script);

    // Cleanup the script on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="booking-container">
      <div className="inner-hero">
        <div className="inner-hero-image">
          <img src={pageData?.pilotBlock?.image} alt="" />
        </div>
        <div className="herotext wow fadeInUp">
          <Container>
            <h1>Book Packages</h1>
          </Container>
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <iframe
          id="glofox_6"
          src="https://rlw.smarthealthclubs.com/v2/deeplink/myclub/department/Sales?tab=Services"
          width="100%"
          height="100vh"
          scrolling="no"
          frameBorder="0"
          title="Book Now"
        ></iframe>
      </div>
    </div>
  );
};

export default BookPackagesV1;
